// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.panel-container {
	display: flex;
	flex-direction: column;
	/* max-width: 500px; */
	height: fit-content;
	z-index: 3001;
	background: var(--primary-color1);
	/* padding: 1rem; */
	align-items: center;
	justify-items: space-between;
	animation: scroll-from-bottom-left 0.5s ease-out forwards;
	flex-basis: 100%;
	position: relative;
	flex-wrap: wrap;
	touch-action: none;
}

.panel-close-button {
	position: absolute;
	right: 5px;
	top: 5px;
	z-index: 5000;
}

.panel-close-button img {
	color: var(--primary-color1);
	width: 30px;
	height: 30px;
	clip-path: polygon(10% 0, 100% 0%, 100% 75%, 10% 0%);
}
.panel-inner-box {
	background: white;
	padding: 1rem;
	margin: 1rem;
	border-radius: 1rem;
	color: var(--secondary-color1);
	max-width: 95vw;
	height: fit-content;
	align-self: center;
	box-shadow: 0px 2px 2px 3px rgba(19, 16, 16, 0.3);
	position: relative;
	max-height: 90vh;
	overflow-y: scroll;
}
.panel-inner-box h1 {
	color: var(--secondary-color1);
	line-height: 1.6rem;
	font-size: 1.6rem;
}
.panel-inner-box p {
	line-height: 1.8rem;
	font-size: 1.5rem;
}
.panel-inner-box p.footnote {
	font-size: 0.8rem;
	font-style: italic;
	line-height: 1rem;
}

.panel-content {
	position: relative;
	margin-top: 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
	height: fit-content;
	/* height:fit-content; */
}
.panel-content.chart {
	z-index: 3002;
	margin: 1rem;
	height: 200px;
	width: 85vw;
}
@media (max-width: 280px) {
	.panel-container {
		width: 100vw;
		height: fit-content;
		z-index: 3001;
		background: var(--primary-color1);
		animation: panel-open-from-left 0.5s ease-out;
	}

	.panel-inner-box {
		margin: 0.5rem;

		background: white;
		color: var(--secondary-color1);
		width: 100%;
		height: fit-content;
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		flex-direction: unset;
		max-height: 90vh;
		overflow-y: scroll;
	}
	.panel-content {
		margin-top: 0.5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: fit-content;
		width: 100%;
		/* height:fit-content; */
	}
}

@media (min-width: 500px) {
	.panel-container {
		display: inline-flex;
		flex-direction: column;
		max-width: unset;
		max-height: unset;
		height: fit-content;
		width: 100%;
		height: fit-content;
		z-index: 3001;
		background: var(--primary-color1);
		padding: 1rem;
		align-items: center;
		animation: panel-open-from-left 0.5s ease-out;
	}
	.panel-container.no-anim {
		animation: unset;
	}
	.panel-inner-box {
		margin-top: unset;
		background: white;
		/* padding: 1rem; */
		border-radius: 1rem;
		color: var(--secondary-color1);
		width: 400px;
		height: fit-content;
		max-height: 90vh;
		overflow-y: scroll;
	}
	.panel-inner-box h1 {
		color: var(--secondary-color1);
		line-height: 2rem;
		font-size: 2rem;
		text-align: center;
	}
	.panel-inner-box p {
		line-height: 2rem;
		font-size: 1.6rem;
		/* text-align: justify; */
		margin: 0.5rem;
	}
	.panel-inner-box p.footnote {
		font-size: 1.2rem;
		font-style: italic;
		line-height: 1.5rem;
	}
	.panel-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-items: center;
		height: fit-content;
		width: 100%;
	}
	.panel-close-button {
		position: absolute;
		right: 5px;
		top: 5px;
	}
	.panel-close-button img {
		clip-path: polygon(10% 0, 100% 0%, 100% 75%, 10% 0%);
		width: 35px;
		height: 35px;
	}

	.panel-content.chart {
		z-index: 3002;
		margin: 1rem;
		width: 100%;
	}
	.panel-content .icons-area {
		width: 100%;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/panel/Panel.css"],"names":[],"mappings":";AACA;CACC,aAAa;CACb,sBAAsB;CACtB,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;CACb,iCAAiC;CACjC,mBAAmB;CACnB,mBAAmB;CACnB,4BAA4B;CAC5B,yDAAyD;CACzD,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,aAAa;AACd;;AAEA;CACC,4BAA4B;CAC5B,WAAW;CACX,YAAY;CACZ,oDAAoD;AACrD;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,iDAAiD;CACjD,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,6BAA6B;CAC7B,mBAAmB;CACnB,wBAAwB;AACzB;AACA;CACC,aAAa;CACb,YAAY;CACZ,aAAa;CACb,WAAW;AACZ;AACA;CACC;EACC,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,6CAA6C;CAC9C;;CAEA;EACC,cAAc;;EAEd,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;CACnB;CACA;EACC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,6CAA6C;CAC9C;CACA;EACC,gBAAgB;CACjB;CACA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;CACnB;CACA;EACC,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;CACf;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;CACZ;CACA;EACC,kBAAkB;EAClB,UAAU;EACV,QAAQ;CACT;CACA;EACC,oDAAoD;EACpD,WAAW;EACX,YAAY;CACb;;CAEA;EACC,aAAa;EACb,YAAY;EACZ,WAAW;CACZ;CACA;EACC,WAAW;CACZ;AACD","sourcesContent":["\n.panel-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\t/* max-width: 500px; */\n\theight: fit-content;\n\tz-index: 3001;\n\tbackground: var(--primary-color1);\n\t/* padding: 1rem; */\n\talign-items: center;\n\tjustify-items: space-between;\n\tanimation: scroll-from-bottom-left 0.5s ease-out forwards;\n\tflex-basis: 100%;\n\tposition: relative;\n\tflex-wrap: wrap;\n\ttouch-action: none;\n}\n\n.panel-close-button {\n\tposition: absolute;\n\tright: 5px;\n\ttop: 5px;\n\tz-index: 5000;\n}\n\n.panel-close-button img {\n\tcolor: var(--primary-color1);\n\twidth: 30px;\n\theight: 30px;\n\tclip-path: polygon(10% 0, 100% 0%, 100% 75%, 10% 0%);\n}\n.panel-inner-box {\n\tbackground: white;\n\tpadding: 1rem;\n\tmargin: 1rem;\n\tborder-radius: 1rem;\n\tcolor: var(--secondary-color1);\n\tmax-width: 95vw;\n\theight: fit-content;\n\talign-self: center;\n\tbox-shadow: 0px 2px 2px 3px rgba(19, 16, 16, 0.3);\n\tposition: relative;\n\tmax-height: 90vh;\n\toverflow-y: scroll;\n}\n.panel-inner-box h1 {\n\tcolor: var(--secondary-color1);\n\tline-height: 1.6rem;\n\tfont-size: 1.6rem;\n}\n.panel-inner-box p {\n\tline-height: 1.8rem;\n\tfont-size: 1.5rem;\n}\n.panel-inner-box p.footnote {\n\tfont-size: 0.8rem;\n\tfont-style: italic;\n\tline-height: 1rem;\n}\n\n.panel-content {\n\tposition: relative;\n\tmargin-top: 0.5rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: space-evenly;\n\theight: fit-content;\n\t/* height:fit-content; */\n}\n.panel-content.chart {\n\tz-index: 3002;\n\tmargin: 1rem;\n\theight: 200px;\n\twidth: 85vw;\n}\n@media (max-width: 280px) {\n\t.panel-container {\n\t\twidth: 100vw;\n\t\theight: fit-content;\n\t\tz-index: 3001;\n\t\tbackground: var(--primary-color1);\n\t\tanimation: panel-open-from-left 0.5s ease-out;\n\t}\n\n\t.panel-inner-box {\n\t\tmargin: 0.5rem;\n\n\t\tbackground: white;\n\t\tcolor: var(--secondary-color1);\n\t\twidth: 100%;\n\t\theight: fit-content;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-content: center;\n\t\tflex-direction: unset;\n\t\tmax-height: 90vh;\n\t\toverflow-y: scroll;\n\t}\n\t.panel-content {\n\t\tmargin-top: 0.5rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: fit-content;\n\t\twidth: 100%;\n\t\t/* height:fit-content; */\n\t}\n}\n\n@media (min-width: 500px) {\n\t.panel-container {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tmax-width: unset;\n\t\tmax-height: unset;\n\t\theight: fit-content;\n\t\twidth: 100%;\n\t\theight: fit-content;\n\t\tz-index: 3001;\n\t\tbackground: var(--primary-color1);\n\t\tpadding: 1rem;\n\t\talign-items: center;\n\t\tanimation: panel-open-from-left 0.5s ease-out;\n\t}\n\t.panel-container.no-anim {\n\t\tanimation: unset;\n\t}\n\t.panel-inner-box {\n\t\tmargin-top: unset;\n\t\tbackground: white;\n\t\t/* padding: 1rem; */\n\t\tborder-radius: 1rem;\n\t\tcolor: var(--secondary-color1);\n\t\twidth: 400px;\n\t\theight: fit-content;\n\t\tmax-height: 90vh;\n\t\toverflow-y: scroll;\n\t}\n\t.panel-inner-box h1 {\n\t\tcolor: var(--secondary-color1);\n\t\tline-height: 2rem;\n\t\tfont-size: 2rem;\n\t\ttext-align: center;\n\t}\n\t.panel-inner-box p {\n\t\tline-height: 2rem;\n\t\tfont-size: 1.6rem;\n\t\t/* text-align: justify; */\n\t\tmargin: 0.5rem;\n\t}\n\t.panel-inner-box p.footnote {\n\t\tfont-size: 1.2rem;\n\t\tfont-style: italic;\n\t\tline-height: 1.5rem;\n\t}\n\t.panel-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-items: center;\n\t\theight: fit-content;\n\t\twidth: 100%;\n\t}\n\t.panel-close-button {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\ttop: 5px;\n\t}\n\t.panel-close-button img {\n\t\tclip-path: polygon(10% 0, 100% 0%, 100% 75%, 10% 0%);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t}\n\n\t.panel-content.chart {\n\t\tz-index: 3002;\n\t\tmargin: 1rem;\n\t\twidth: 100%;\n\t}\n\t.panel-content .icons-area {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
